import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './ai-governance-risk-compliance-ai-grc.css'

const AIGovernanceRiskComplianceAIGRC = (props) => {
  return (
    <div className="ai-governance-risk-compliance-aigrc-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="AI-Governance-Risk-Compliance-AI-GRC - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/ai-governance-risk-compliance-ai-grc"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <video
          src="https://videos.pexels.com/video-files/18333010/18333010-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="ai-governance--risk---compliance--ai-grc--hero-overlay hero-overlay"></div>
        <div className="ai-governance--risk---compliance--ai-grc--hero-content">
          <div className="ai-governance--risk---compliance--ai-grc--hero-content-inner">
            <h1 className="hero-title ai-governance--risk---compliance--ai-grc--hero-title">
              AI Governance, Risk &amp; Compliance
            </h1>
            <p className="ai-governance--risk---compliance--ai-grc--hero-subtitle hero-subtitle">
              Build trustworthy AI systems through comprehensive governance
              frameworks, proactive risk management, and regulatory alignment
            </p>
            <div className="hero-cta-group ai-governance--risk---compliance--ai-grc--hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request AI GRC Assessment</span>
                </div>
              </a>
              <a href="#process">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Our Approach</span>
                  
                </div>
              </a>
            </div>
            <div className="hero-badges">
              <div className="hero-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>ISO Compliant</span>
              </div>
              <div className="hero-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>AI Ethics Certified</span>
              </div>
              <div className="hero-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
                <span>Global Regulatory Expertise</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="benefits-section">
        <div className="benefits-container">
          <div className="benefits-header">
            <h2 className="section-title">Why AI GRC Matters</h2>
            <p className="section-subtitle">
              Comprehensive AI governance that mitigates risk, ensures
              regulatory alignment, and enables trusted AI deployments
            </p>
          </div>
          <div className="benefits-grid">
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="benefits-title">Risk Mitigation</h3>
              <p className="benefits-description">
                Identify and address AI-specific risks including bias,
                transparency gaps, data privacy concerns, and model reliability
                issues before they impact operations
              </p>
            </div>
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-title">Regulatory Compliance</h3>
              <p className="benefits-description">
                Navigate evolving AI regulations including EU AI Act, data
                protection laws, and sector-specific requirements with
                confidence and precision
              </p>
            </div>
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-title">Stakeholder Trust</h3>
              <p className="benefits-description">
                Build confidence among customers, regulators, and partners
                through transparent, accountable, and ethically sound AI
                practices
              </p>
            </div>
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-title">Operational Resilience</h3>
              <p className="benefits-description">
                Establish robust governance structures, incident response
                procedures, and continuous monitoring systems for AI system
                reliability
              </p>
            </div>
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-title">Competitive Advantage</h3>
              <p className="benefits-description">
                Differentiate your organization with mature AI governance that
                accelerates responsible innovation and market adoption
              </p>
            </div>
            <div className="benefits-card">
              <div className="benefits-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-title">Quality Assurance</h3>
              <p className="benefits-description">
                Implement validation frameworks, testing protocols, and
                performance metrics ensuring AI systems deliver accurate and
                reliable outcomes
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="ai-governance--risk---compliance--ai-grc--challenges-section">
        <div className="ai-governance--risk---compliance--ai-grc--challenges-header">
          <h2 className="section-title">Common AI Governance Challenges</h2>
          <p className="section-subtitle">
            Enterprise organizations face complex obstacles when deploying AI
            systems at scale
          </p>
        </div>
        <div className="challenges-timeline">
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">Lack of AI-Specific Policies</h3>
              <p className="challenges-description">
                Most organizations lack formalized policies governing AI
                development, deployment, and monitoring, leading to inconsistent
                practices
              </p>
            </div>
          </div>
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 8v4m0 4h.01"></path>
                </g>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">
                Algorithmic Bias &amp; Fairness
              </h3>
              <p className="challenges-description">
                Identifying and mitigating discriminatory outcomes, ensuring
                equitable treatment across demographic groups and use cases
              </p>
            </div>
          </div>
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    rx="2"
                    ry="2"
                    width="18"
                    height="11"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </g>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">Data Privacy &amp; Security</h3>
              <p className="challenges-description">
                Protecting sensitive data used in training and inference while
                complying with GDPR, CCPA, and emerging privacy regulations
              </p>
            </div>
          </div>
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="8"
                    y="2"
                    rx="1"
                    ry="1"
                    width="8\\"
                    height='\\"4"'
                  ></rect>
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m4 7h4m-4 5h4m-8-5h.01M8 16h.01"></path>
                </g>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">
                Transparency &amp; Explainability
              </h3>
              <p className="challenges-description">
                Ensuring AI decision-making processes are understandable,
                auditable, and explainable to stakeholders and regulators
              </p>
            </div>
          </div>
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                </g>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">Regulatory Fragmentation</h3>
              <p className="challenges-description">
                Navigating conflicting requirements across jurisdictions,
                industries, and rapidly evolving AI regulatory landscapes
              </p>
            </div>
          </div>
          <div className="challenges-item">
            <div className="challenges-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  <path d="M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"></path>
                </g>
              </svg>
            </div>
            <div className="challenges-content">
              <h3 className="challenges-title">Model Performance Drift</h3>
              <p className="challenges-description">
                Detecting and addressing degradation in AI model accuracy,
                reliability, and behavior over time in production environments
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-section">
        <div className="process-container">
          <div className="process-header">
            <h2 className="section-title">Our AI GRC Methodology</h2>
            <p className="section-subtitle">
              A comprehensive approach to AI risk assessment, governance design,
              and compliance mapping
            </p>
          </div>
          <div className="ai-governance--risk---compliance--ai-grc--process-steps">
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>01</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  AI Landscape Assessment
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Conduct comprehensive inventory of AI systems, use cases, and
                  data flows. Identify high-risk applications, stakeholders, and
                  existing governance gaps across the organization
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">AI System Inventory</span>
                  <span className="process-tag">Risk Heat Map</span>
                  <span className="process-tag">Stakeholder Analysis</span>
                </div>
              </div>
            </div>
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>02</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  Risk Identification &amp; Analysis
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Evaluate technical, operational, ethical, and compliance
                  risks. Assess bias potential, data quality issues, security
                  vulnerabilities, and regulatory exposure for each AI system
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">Risk Register</span>
                  <span className="process-tag">Impact Assessment</span>
                  <span className="process-tag">Threat Modeling</span>
                </div>
              </div>
            </div>
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>03</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  Governance Framework Design
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Develop tailored AI governance policies, procedures, and
                  controls aligned with organizational objectives and regulatory
                  requirements. Define roles, responsibilities, and
                  accountability structures
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">Policy Framework</span>
                  <span className="process-tag">RACI Matrix</span>
                  <span className="process-tag">Control Catalog</span>
                </div>
              </div>
            </div>
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>04</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  Compliance Mapping
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Map AI systems and processes to applicable regulations
                  including EU AI Act, data privacy laws, sector-specific rules.
                  Identify compliance gaps and prioritize remediation efforts
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">Compliance Matrix</span>
                  <span className="process-tag">Gap Analysis</span>
                  <span className="process-tag">Requirements Traceability</span>
                </div>
              </div>
            </div>
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>05</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  Implementation Support
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Guide deployment of governance controls, testing frameworks,
                  and monitoring systems. Provide training, documentation, and
                  change management support to ensure successful adoption
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">Implementation Roadmap</span>
                  <span className="process-tag">Training Materials</span>
                  <span className="process-tag">Monitoring Dashboards</span>
                </div>
              </div>
            </div>
            <div className="ai-governance--risk---compliance--ai-grc--process-step">
              <div className="ai-governance--risk---compliance--ai-grc--process-number">
                <span>06</span>
              </div>
              <div className="process-content">
                <h3 className="ai-governance--risk---compliance--ai-grc--process-title">
                  Continuous Monitoring &amp; Improvement
                </h3>
                <p className="ai-governance--risk---compliance--ai-grc--process-description">
                  Establish ongoing review processes, performance metrics, and
                  audit procedures. Adapt governance frameworks to evolving
                  regulations, technologies, and organizational needs
                </p>
                <div className="process-deliverables">
                  <span className="process-tag">Audit Protocol</span>
                  <span className="process-tag">KPI Dashboard</span>
                  <span className="process-tag">Improvement Plan</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="deliverables-section">
        <div className="deliverables-container">
          <div className="deliverables-header">
            <h2 className="section-title">Concrete Deliverables</h2>
            <p className="section-subtitle">
              Tangible outputs that establish robust AI governance, ensure
              compliance, and enable responsible AI deployment
            </p>
          </div>
          <div className="deliverables-grid">
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverables-title">AI GRC Framework Document</h3>
              <p className="deliverables-description">
                Comprehensive governance framework including principles,
                policies, standards, and procedures for responsible AI
                development and deployment
              </p>
            </div>
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2m4 7h4m-4 5h4m-8-5h.01M8 16h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverables-title">AI Risk Register</h3>
              <p className="deliverables-description">
                Detailed inventory of identified risks with severity ratings,
                mitigation strategies, ownership assignments, and tracking
                mechanisms
              </p>
            </div>
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverables-title">Compliance Mapping Matrix</h3>
              <p className="deliverables-description">
                Crosswalk of AI systems to regulatory requirements with gap
                analysis, control mappings, and evidence collection protocols
              </p>
            </div>
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverables-title">Model Governance Playbook</h3>
              <p className="deliverables-description">
                Operational procedures for AI model validation, approval
                workflows, performance monitoring, and lifecycle management
              </p>
            </div>
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="deliverables-title">Remediation Roadmap</h3>
              <p className="deliverables-description">
                Prioritized action plan with timelines, resource requirements,
                and success metrics for addressing identified governance and
                compliance gaps
              </p>
            </div>
            <div className="deliverables-card">
              <div className="deliverables-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="deliverables-title">Incident Response Protocol</h3>
              <p className="deliverables-description">
                Structured procedures for detecting, responding to, and
                recovering from AI system failures, security incidents, and
                ethical breaches
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="regulatory-section">
        <div className="regulatory-header">
          <h2 className="section-title">Regulatory Compliance Crosswalk</h2>
          <p className="section-subtitle">
            AI-related regulatory requirements mapped to controls and
            implementation guidance
          </p>
        </div>
        <div className="regulatory-timeline">
          <div className="regulatory-item">
            <div className="regulatory-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                </g>
              </svg>
            </div>
            <div className="regulatory-content">
              <h3 className="regulatory-title">EU AI Act</h3>
              <p className="regulatory-description">
                Comprehensive AI regulation requiring risk classification,
                conformity assessments, transparency obligations, and human
                oversight for high-risk AI systems
              </p>
              <div className="regulatory-controls">
                <span className="regulatory-tag">Risk Classification</span>
                <span className="regulatory-tag">Technical Documentation</span>
                <span className="regulatory-tag">
                  Transparency Requirements
                </span>
              </div>
            </div>
          </div>
          <div className="regulatory-item">
            <div className="regulatory-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    rx="2"
                    ry="2"
                    width="18"
                    height="11"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </g>
              </svg>
            </div>
            <div className="regulatory-content">
              <h3 className="regulatory-title">GDPR &amp; Data Privacy</h3>
              <p className="regulatory-description">
                Data protection requirements for AI including lawful processing,
                data minimization, purpose limitation, and rights to explanation
                for automated decision-making
              </p>
              <div className="regulatory-controls">
                <span className="regulatory-tag">
                  Data Protection Impact Assessment
                </span>
                <span className="regulatory-tag">
                  Automated Decision Rights
                </span>
                <span className="regulatory-tag">Privacy by Design</span>
              </div>
            </div>
          </div>
          <div className="regulatory-item">
            <div className="regulatory-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <div className="regulatory-content">
              <h3 className="regulatory-title">Algorithmic Accountability</h3>
              <p className="regulatory-description">
                Requirements for fairness testing, bias audits, impact
                assessments, and explainability documentation for AI systems
                affecting individuals
              </p>
              <div className="regulatory-controls">
                <span className="regulatory-tag">Bias Testing</span>
                <span className="regulatory-tag">Fairness Metrics</span>
                <span className="regulatory-tag">Impact Documentation</span>
              </div>
            </div>
          </div>
          <div className="regulatory-item">
            <div className="regulatory-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <div className="regulatory-content">
              <h3 className="regulatory-title">Sector-Specific Standards</h3>
              <p className="regulatory-description">
                Industry regulations for AI in healthcare, finance, insurance,
                and employment requiring safety, accuracy, and
                non-discrimination standards
              </p>
              <div className="regulatory-controls">
                <span className="regulatory-tag">Clinical Validation</span>
                <span className="regulatory-tag">
                  Financial Model Risk Management
                </span>
                <span className="regulatory-tag">Fair Lending Compliance</span>
              </div>
            </div>
          </div>
          <div className="regulatory-item">
            <div className="regulatory-marker">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="regulatory-content">
              <h3 className="regulatory-title">Cybersecurity Requirements</h3>
              <p className="regulatory-description">
                Security controls for AI systems including adversarial
                robustness, model protection, secure development practices, and
                incident response protocols
              </p>
              <div className="regulatory-controls">
                <span className="regulatory-tag">Adversarial Testing</span>
                <span className="regulatory-tag">Model Security</span>
                <span className="regulatory-tag">Secure AI Pipeline</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ai-governance--risk---compliance--ai-grc--cta-section">
        <div className="cta-container">
          <div className="ai-governance--risk---compliance--ai-grc--cta-card">
            <div className="ai-governance--risk---compliance--ai-grc--cta-content">
              <h2 className="section-title">
                Ready to Build Trusted AI Systems?
              </h2>
              <p className="section-subtitle">
                Partner with our AI governance experts to establish robust
                frameworks, ensure regulatory compliance, and accelerate
                responsible AI adoption
              </p>
              <div className="cta-stats">
                <div className="cta-stat">
                  <div className="cta-stat-value">
                    <span>50+</span>
                  </div>
                  <div className="cta-stat-label">
                    <span>AI GRC Assessments team</span>
                  </div>
                </div>
                <div className="cta-stat">
                  <div className="cta-stat-value">
                    <span>15+</span>
                  </div>
                  <div className="cta-stat-label">
                    <span>Industries Served</span>
                  </div>
                </div>
                <div className="cta-stat">
                  <div className="cta-stat-value">
                    <span>100%</span>
                  </div>
                  <div className="cta-stat-label">
                    <span>Compliance Success Rate</span>
                  </div>
                </div>
              </div>
              <div className="cta-buttons">
                <a href="#contact">
                  <div className="btn-primary btn-xl btn">
                    <span>Request AI GRC Consultation</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-image">
              <img
                alt="AI neural network visualization representing governance and compliance"
                src="https://images.pexels.com/photos/17486100/pexels-photo-17486100.png?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="ai-governance-risk-compliance-aigrc-container2">
        <div className="ai-governance-risk-compliance-aigrc-container3">
          <Script
            html={`<script defer data-name="hero-video-optimization">
(function(){
  const heroVideo = document.querySelector(".hero-video")
  if (heroVideo) {
    heroVideo.play().catch(() => {})
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const allAnimatedElements = document.querySelectorAll(".benefits-card, .process-step, .deliverables-card, .cases-card, .team-card")
    allAnimatedElements.forEach((el) => {
      el.style.transition = "none"
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AIGovernanceRiskComplianceAIGRC
